import React from 'react';

import { RATIO_FIELDS } from '../constants/defaultFormValues';

function parseNumber(value) {
  const parsed = Number(value);
  return Number.isFinite(parsed) ? parsed : 0;
}

export default function UploadForm({
  form,
  onFieldChange,
  onFileChange,
  onRefresh,
  onSubmit,
  refreshing,
  submitting
}) {
  return (
    <section className="panel panel--accent">
      <div className="panel__header">
        <div>
          <span className="panel__eyebrow">Create workbook</span>
          <h2>Upload and generate</h2>
          <p>Choose the Excel file, set the message timing, and build a downloadable report.</p>
        </div>
      </div>

      <form className="upload-form" onSubmit={onSubmit}>
        <div className="field-grid">
          <label className="field field--full" htmlFor="file">
            <span>Excel source file</span>
            <input
              id="file"
              accept=".xlsx,.xls"
              type="file"
              onChange={(event) => onFileChange('file', event.target.files && event.target.files[0] ? event.target.files[0] : null)}
            />
            <small>{form.file ? `Selected: ${form.file.name}` : 'The app scans the first few columns and keeps the first valid mobile number.'}</small>
          </label>

          <label className="field field--full" htmlFor="media">
            <span>Optional media file</span>
            <input
              id="media"
              accept="image/*,video/*"
              type="file"
              onChange={(event) => onFileChange('media', event.target.files && event.target.files[0] ? event.target.files[0] : null)}
            />
            <small>{form.media ? `Selected: ${form.media.name}` : 'Media is optional and its filename is added to the report.'}</small>
          </label>

          <label className="field field--full" htmlFor="message">
            <span>Message</span>
            <textarea
              id="message"
              rows={5}
              value={form.message}
              onChange={(event) => onFieldChange('message', event.target.value)}
            />
            <small>The same message is written into every generated row.</small>
          </label>

          <label className="field" htmlFor="campaignDatetime">
            <span>Campaign date and time</span>
            <input
              id="campaignDatetime"
              type="datetime-local"
              value={form.campaignDatetime}
              onChange={(event) => onFieldChange('campaignDatetime', event.target.value)}
            />
            <small>Sent timestamps are calculated from this starting point.</small>
          </label>

          <label className="field" htmlFor="rate">
            <span>Rate (messages per second)</span>
            <input
              id="rate"
              min={1}
              type="number"
              value={form.rate}
              onChange={(event) => onFieldChange('rate', parseNumber(event.target.value))}
            />
            <small>Higher rates create denser timestamp spacing.</small>
          </label>
        </div>

        <div className="ratio-section">
          <div className="ratio-section__head">
            <h3>Status ratios</h3>
            <p>These values are normalized automatically before the report is generated.</p>
          </div>

          <div className="ratio-grid">
            {RATIO_FIELDS.map((field) => (
              <label className="field" htmlFor={field.key} key={field.key}>
                <span>{field.label}</span>
                <input
                  id={field.key}
                  min={0}
                  type="number"
                  value={form[field.key]}
                  onChange={(event) => onFieldChange(field.key, parseNumber(event.target.value))}
                />
              </label>
            ))}
          </div>
        </div>

        <div className="form-actions">
          <button className="button" disabled={submitting} type="submit">
            {submitting ? 'Generating workbook...' : 'Generate Excel report'}
          </button>
          <button className="button button--secondary" disabled={refreshing} onClick={onRefresh} type="button">
            {refreshing ? 'Refreshing...' : 'Refresh reports'}
          </button>
        </div>
      </form>
    </section>
  );
}
